import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const wid = localStorage.getItem("hop_workspace_id");
  if (wid && !config.params?.workspace_id) {
    config.params = { ...(config.params || {}), workspace_id: wid };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hop_token");
      localStorage.removeItem("hop_workspace_id");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const PILLARS = {
  building_bts: "Building BTS",
  product_development: "Product Development",
  wins_failures: "Wins & Failures",
  fitness_lifestyle: "Fitness & Lifestyle",
  team_culture: "Team & Culture",
};

export const FORMATS = {
  talking_head_reel: "Talking-head Reel",
  vlog_reel: "Vlog Reel",
  carousel: "Carousel",
  interview_clip: "Interview Clip",
  stories_sequence: "Stories Sequence",
  experimental: "Experimental",
};

export const CONFIDENCE_STYLES = {
  high: { label: "Proven", cls: "bg-emerald-100 text-emerald-900 border-emerald-400" },
  medium: { label: "Promising", cls: "bg-orange-100 text-orange-900 border-orange-400" },
  low: { label: "Insufficient Data", cls: "bg-transparent text-zinc-600 border-zinc-400 border-dashed" },
  experiment: { label: "Experimental", cls: "bg-indigo-100 text-indigo-900 border-indigo-400" },
};

export function EvidenceBadge({ confidence }) {
  const s = CONFIDENCE_STYLES[confidence] || CONFIDENCE_STYLES.medium;
  return (
    <span
      data-testid={`evidence-badge-${confidence}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.05em] border ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
